import { useAppState, useAppDispatch } from '../Context'
import Downshift from 'downshift'

function LocationSearch() {
  const dispatch = useAppDispatch()
  const { locations } = useAppState()

  const handleChange = (selection, downshift) => {
    if (selection) {
      downshift.clearSelection(() => {
        dispatch({ type: 'setSelectedLocation', payload: selection })
      })
    }
  }

  return (
    <Downshift onChange={handleChange} itemToString={(item) => (item ? item.title : '')}>
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        getMenuProps,
        getToggleButtonProps,
        isOpen,
        inputValue,
        highlightedIndex,
        getRootProps,
      }) => (
        <div className="hidden absolute top-6 right-6 z-10 w-96 md:block">
          <label {...getLabelProps()} className="sr-only">
            Find Location by Keyword or Name
          </label>
          <div {...getRootProps({}, { suppressRefError: true })} className="relative w-full">
            <input
              {...getInputProps()}
              placeholder="Find Location by Keyword or Name"
              className="block py-3 pr-12 pl-4 w-full text-base bg-white border"
            />
            <button
              {...getToggleButtonProps()}
              aria-label={'Toggle Menu'}
              className="flex absolute top-0 right-0 flex-shrink-0 w-12 h-full"
            >
              <svg viewBox="0 0 18 18" className="m-auto w-5 h-5">
                <path
                  d="M17.71 16.29a1.004 1.004 0 0 1-1.42 1.42l-3.38-3.39a8 8 0 1 1 1.41-1.41l3.39 3.38ZM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
          {isOpen && (
            <ul
              {...getMenuProps()}
              className="overflow-scroll mt-2 text-sm bg-white border overflow-scroll-touch max-h-[300px]"
            >
              {locations
                .filter((item) => !inputValue || item.title.toLowerCase().includes(inputValue.toLowerCase()))
                .map((item, index) => (
                  <li
                    {...getItemProps({
                      key: item.id,
                      index,
                      item,
                      className: `${highlightedIndex === index ? 'bg-gray-lightest' : ''} py-2 px-3 cursor-pointer`,
                    })}
                  >
                    {item.title}
                  </li>
                ))}
            </ul>
          )}
        </div>
      )}
    </Downshift>
  )
}

export default LocationSearch
